import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import _ from 'lodash';
import { createWorkflow, fetchWorkflow } from '../actions';
import { selectConfig, selectWorks } from '../../Api/selectors';
import { REQUEST_CREATE_WORKFLOW, WORKFLOW_STATUSES } from '../constants';
import { Loader } from '../../../components/Loader';
import { selectProducts } from '../../products/selectors';
import { WORKFLOW_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './CreateWorkflowModal.module.css';

const STATE = {
  showAddProductModal: false,
};

class CreateWorkflowModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get workflow() {
    return this.props.workflow;
  }

  getFieldValue(name) {
    if (!this.props.workflow_id) return this.state[name];
    if (!this.workflow) return null;
    return this.state[name] !== undefined ? this.state[name] : this.workflow[name];
  }

  get status() {
    const value = this.getFieldValue('status');
    if (Object.values(WORKFLOW_STATUSES).includes(value)) return value;
    return WORKFLOW_STATUSES.OPEN;
  }

  onStringInputChange(evt) {
    this.updateState(evt.target.name, evt.target.value);
  }

  get isFinal() {
    return this.workflow?.status === WORKFLOW_STATUSES.FINAL;
  }

  reset() {
    this.setState(prev => ({ ...STATE }));
  }

  get saveDisabled() {
    return !this.getFieldValue('name') || !this.getFieldValue('nameOnInvoice') || this.isFinal;
  }

  onSave() {
    const dto = {
      name: this.getFieldValue('name'),
      nameOnInvoice: this.getFieldValue('nameOnInvoice'),
    };
    if (!this.props.workflow_id) {
      this.props.create(dto, result => {
        this.reset();

        if (result.id) this.to(`/workflows/${result.id}`);
      });
    }
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Permission permission={WORKFLOW_CRUD}>
        <ModalComponent onClose={this.tofn('/workflows')}>
          <FormField label={this.lbl('workflows.details.name')}>
            <input
              className="form-control"
              name={'name'}
              value={this.getFieldValue('name')}
              onChange={this.onStringInputChange.bind(this)}
            />
          </FormField>

          <FormField label={this.lbl('workflows.details.nameOnInvoice')}>
            <input
              name={'nameOnInvoice'}
              className="form-control"
              value={this.getFieldValue('nameOnInvoice')}
              onChange={this.onStringInputChange.bind(this)}
              required={true}
              disabled={this.isFinal}
            />
          </FormField>

          <HBox left className="field-block">
            <FormField label={this.lbl('workflows.details.status')}>
              <p>{this.lbl(`workflows.details.status.${this.status}`)}</p>
            </FormField>
          </HBox>

          <div className={styles.buttonContainer}>
            <div className={styles.rowButtonsWrapper}>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.tofn('/workflows')}>
                {this.lbl('workflows.details.resetBtn')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftEdit'} disabled={this.saveDisabled} onClick={this.onSave.bind(this)}>
                {this.lbl('workflows.details.saveBtn')}
              </ButtonComponent>
            </div>
          </div>
        </ModalComponent>
      </Permission>
    );
  }
}

CreateWorkflowModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_CREATE_WORKFLOW]),
    availableProducts: selectProducts(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createWorkflow(dto, callback));
    },
    fetch() {
      dispatch(fetchWorkflow(ownProps.workflow_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const CreateWorkflowModal = compose(withConnect, withRouter)(CreateWorkflowModalComp);
